import { Grid } from "@material-ui/core";
import { FileSaveIcon } from "App/Assets";
import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { today } from "App/utils/helpers";
import React, { useState } from "react";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

import ModalSimpan from "./ModalSimpan/ModalSimpan";

export const urlCreate = LIST_URL_WAREHOUSE.stockOpnameLGS.add;
export const urlUploadStockOpname = LIST_URL_WAREHOUSE.stockOpnameLGS.upload;
export const urlListItemByStockOpname =
  LIST_URL_WAREHOUSE.stockOpnameLGS.getById;
export const urlAcceptStockOpname = LIST_URL_WAREHOUSE.stockOpnameLGS.accept;

export const RESET_STATE_STOCK_OPNAME = {
  id: "",
  date: today(true),
  gudang: "Pilih Gudang",
  gudang_id: null,
  status: 0,
};

export const getListItemByStockOpname = async (id) => {
  try {
    const api = await instance4.get(`${urlListItemByStockOpname}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const RenderSimpanButton = ({
  formData,
  setFormData,
  setNewAllData,
  setFormFilterBarangByGudang,
  formFilterBarangByGudang,
}) => {
  const [showModalSimpan, setShowModalSimpan] = useState(false);

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          formData={formData}
          setFormData={setFormData}
          setNewAllData={setNewAllData}
          setFormFilterBarangByGudang={setFormFilterBarangByGudang}
          formFilterBarangByGudang={formFilterBarangByGudang}
        />
      )}
      <div className='mt-2'>
        <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            outline={true}
            type={"button"}
            color='danger'
            name='RESET'
            onClick={() => setFormData(RESET_STATE_STOCK_OPNAME)}
            size='md'
          />
          <MasterButton
            outline={false}
            type={"submit"}
            color='lightgreen'
            name='SIMPAN'
            size='md'
            onClick={() => setShowModalSimpan(!showModalSimpan)}
            withIcon={true}
            icon={<FileSaveIcon width='18px' height='18px' />}
          />
        </Grid>
      </div>
    </>
  );
};
